import EnumConfig from './EnumConfig.jsx';

export default function SelectConfig({ field, onConfigChange }) {
  return <EnumConfig field={field} onConfigChange={onConfigChange} />;
}
